import { getHighlights, scrollToElement } from 'services/highlightService'

let initialized = false

const state = {
  totalOccurrences: 0,
  currentOccurrence: 0
}

const mutations = {
  setCurrentOccurrence(state, data) { state.currentOccurrence = data },
  calculateOccurrences(state) {
    const highlightList = getHighlights()
    state.totalOccurrences = highlightList.length
  },
  resetOccurrences(state) {
    state.totalOccurrences = 0
    state.currentOccurrence = 0
  }
}

const actions = {
  calculateOccurrences({ commit, state }) {
    commit('calculateOccurrences')
  },
  goNearHighlight({ commit }, { element, next }) {
    const list = getHighlights()
    if (!list.length) return

    const index = list.index($(element).closest('[data-highlight]'))

    let target = (index + (next ? 1 : -1)) % list.length
    if (target < 0) target = list.length - 1

    commit('setCurrentOccurrence', target + 1)
    scrollToElement(list.eq(target)[0])
  },
  goFirstHightlight({ commit }) {
    const list = getHighlights()
    const target = list.first()[0]

    if (target) {
      commit('setCurrentOccurrence', 1)
      scrollToElement(target)
    }
  },
  goLastHighlight({ commit }) {
    const list = getHighlights()
    const target = list.last()[0]

    if (target) {
      commit('setCurrentOccurrence', list.length)
      scrollToElement(target)
    }
  },
  initializeHighlight({ dispatch }) {
    if (initialized) return
    initialized = true

    $(document).on('click.highlight', '.highlight_first', () => {
      dispatch('goFirstHightlight')
    })

    $(document).on('click.highlight', '.highlight_prev', (event) => {
      dispatch('goNearHighlight', { element: event.target, next: false })
    })

    $(document).on('click.highlight', '.highlight_next', (event) => {
      dispatch('goNearHighlight', { element: event.target, next: true })
    })

    $(document).on('click.highlight', '.highlight_last', () => {
      dispatch('goLastHighlight')
    })
  },
  destroyHighlight() {
    $(document).off('.highlight')
    initialized = false
  }
}

export default {
  namespaced: true,
  name: 'highlight',
  state,
  mutations,
  actions
}
